angular.module('am4').directive('validFile',function() {
    return {
        require: 'ngModel',
        link: function(scope, el, attrs, ctrl) {
            ctrl.$setValidity('validFile', el.val() !== '');
            // change event is fired when file is selected
            el.bind('change', function() {
                ctrl.$setValidity('validFile', el.val() !== '');
                scope.$apply(function() {
                    ctrl.$setViewValue(el.val());
                    ctrl.$render();
                });
            });
        }
    };
});


// WEBPACK FOOTER //
// ./src/app/directives/validFile.js